import script from "./ClientTaskEditForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientTaskEditForm.vue?vue&type=script&setup=true&lang=js"

import "./ClientTaskEditForm.vue?vue&type=style&index=0&id=361182de&scoped=true&lang=css"

import exportComponent from "/Users/gordonwong/Shedd/aerocle-client/aerocle-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-361182de"]])

export default __exports__